// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2189":"4b946e2b","7319":"31d6cfe0","8791":"71d8e2a9"}[chunkId] + ".chunk.css";
};